import React from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { motion } from 'framer-motion';
import BoxedContainer from '../layouts/BoxedContainer';

export default function AcademiesCards({ data, id }) {
  const { title, dswAcademyCardList } = data;
  return (
    <section id={id} className="lg:pt-[150px] pt-[70px] lg:pb-[180px] pb-[90px] bg-white">
      <BoxedContainer className="regular">
        <div
          className="flex md:flex-row flex-col lg:gap-x-[90px] gap-x-[60px] md:gap-y-0
          gap-y-[30px] justify-between">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col lg:gap-y-[46px] md:gap-y-[25px] gap-y-[15px] 2xl:w-[65%]
            md:w-[80%]">
            {isEmpty(title) || (
              <h2
                className="lg:text-2xl text-[35px]
                leading-normal text-primary uppercase font-roboto-condensed-bold">
                {title}
              </h2>
            )}
          </motion.div>
        </div>
        {isEmpty(dswAcademyCardList) || (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 pt-5 lg:pt-14 gap-3 md:gap-5">
            {dswAcademyCardList.map((item, index) => (
              <div key={index} className="flex flex-col bg-[#F2F2F2] p-5 md:p-7 xl:p-9">
                <div
                  className="flex h-[90px] md:h-[110px] 2xl:h-[140px] w-full 
                bg-[#F2F2F2]">
                  <LazyLoadImage
                    src={item?.content?.icon?.url}
                    className="h-auto max-h-[70px] md:max-h-[90px] 2xl:max-h-[100px] 
                    mix-blend-darken"
                  />
                </div>
                <p
                  className="font-roboto-condensed-bold text-[14px] md:text-[18px] 2xl:text-[20px] 
                  leading-[1.1] uppercase">
                  {item.content.title}
                </p>
              </div>
            ))}
          </div>
        )}
      </BoxedContainer>
    </section>
  );
}
